export default __webpack_public_path__ + "static/vivax3-f67912edaffc3d91bf77ed68b62c188c.jpg";